import { Field } from '@chakra-ui/react'
import { Checkbox } from 'uikit/Checkbox/Checkbox'

export const CheckboxForm = ({ field, form, label, ...props }) => {
  const handleCheckbox = (e) => form.setFieldValue(field.name, e.checked)
  return (
    <Field.Root>
      <Checkbox
        checked={form.values[field.name] || false}
        onCheckedChange={handleCheckbox}
        {...props}
      >
        {label}
      </Checkbox>
    </Field.Root>
  )
}
